import { render, staticRenderFns } from "./MenuClients.vue?vue&type=template&id=349f2915&scoped=true&"
import script from "./MenuClients.vue?vue&type=script&lang=js&"
export * from "./MenuClients.vue?vue&type=script&lang=js&"
import style0 from "./MenuClients.vue?vue&type=style&index=0&id=349f2915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f2915",
  null
  
)

export default component.exports